export enum Breakpoints {
  MOBILE = 768,
  TABLET = 1024,
  NOTEBOOK = 1366,
  DESKTOP = 1600,
}
